import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Utils } from 'src/modules/utils/shared/utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let headers = req.headers;
        let token = MainAppService.instance.auth.getToken();
        if (!Utils.isNoe(token)) {
            headers = headers.set('Authorization', "Bearer " + token);
        }
        if (MainAppService.instance.auth.usesHttpOnlyAuthenticationCookie()) {
            headers = headers.set("portal-authentication-mode", "cookie");
            headers = headers.set("portal-csrf", "1");
        }
        let frontendVersion = (window as any).frontendVersion as string;
        if (!Utils.isNoe(frontendVersion)) {
            headers = headers.set('frontend-version', frontendVersion);
        }
        let authReq = req.clone({headers});

        return next.handle(authReq).pipe(
            map((event: HttpEvent<any>) => {
                if (event.type == HttpEventType.Response) {
                    if (event.headers.get("portal-authentication-cookie") == "set") {
                        MainAppService.instance.auth.authenticationCookieWasSet();
                    }
                    MainAppService.instance.backendVersionRetrieved(event.headers.get("backend-version"), event.headers.get("frontend-version"));
                    if (event.status === 401) {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        MainAppService.instance.auth.clearLogin();
                    }
                }
                return event;
            }),
            catchError(error => {
                MainAppService.instance.handlePortalBackendErrorId(error.headers.get("portal-backend-error-id") as string);
                if (error.status === 401) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    MainAppService.instance.auth.clearLogin();
                }
                return throwError(() => error);
            }));
    }
}